// @ts-nocheck

import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest, initialFetchListParams } from './index';
export const convertDataToServer = bioTreatmentFacilityTalon => ({
  ...bioTreatmentFacilityTalon,
  sum: convertFromRubToKop(bioTreatmentFacilityTalon.sum)
});
export const convertDataFromServer = bioTreatmentFacilityTalon => ({
  ...bioTreatmentFacilityTalon,
  sum: convertFromKopToRub(bioTreatmentFacilityTalon.sum)
});
const baseUrl = 'bioTreatmentFacilityTalon';
const bioTreatmentFacilityTalon = new CommonApi(baseUrl, 'учет БОС', convertDataToServer, convertDataFromServer);
const print = async id => {
  const print = await downloadRequestWithToken(`/${baseUrl}/${id}/print`);
  if (print) return print;
  throw new Error('Не удалось распечатать');
};
const list = async (params = initialFetchListParams) => {
  const list = await fetchRequest.get(`/${baseUrl}/talonList`, {
    ...initialFetchListParams,
    ...params
  });
  if (list) {
    return list;
  }
  throw new Error('Не удалось получить список');
};
export default {
  ...bioTreatmentFacilityTalon,
  print,
  list
};
